{% block sw_help_text %}
    <span class="ecocode-trustpilot-danger-text"
          v-tooltip="{
            message: text,
            width: width,
            position: tooltipPosition,
            showDelay: showDelay,
            hideDelay: hideDelay
          }">
        {% block sw_help_text_icon %}
            <sw-icon size="12" name="regular-exclamation-s"></sw-icon>
        {% endblock %}
    </span>
{% endblock %}
